export const PLATFORM_ENTITY = 'Authentic';

/** Item/product color class for catalog and invoice item rows. Use this so colors stay consistent. */
export const ITEM_COLOR_CLASS = 'bg-main-200';

export const USER_COLORS = [
  'bg-royal',
  'bg-forest',
  'bg-amber',
  'bg-purple',
  'bg-magenta',
  'bg-asset-green',
  'bg-liability-red',
  'bg-income-blue',
] as const;

const USER_COLOR_HEX: Record<(typeof USER_COLORS)[number], string> = {
  'bg-royal': '#0735F5',
  'bg-forest': '#449A00',
  'bg-amber': '#FF4900',
  'bg-purple': '#A53DE7',
  'bg-magenta': '#FF00D7',
  'bg-asset-green': '#5AC93B',
  'bg-liability-red': '#EC3425',
  'bg-income-blue': '#53BEF9',
};

/**
 * Maps a seed string (e.g. a user's `external_id`) to one of the available
 * user color classes. The mapping is deterministic so the same seed always
 * gets the same color.
 */
export const getStableUserColor = (seed: string): string => {
  const hash = seed
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return USER_COLORS[hash % USER_COLORS.length];
};

/** Darken a hex color by a given factor (0–1, where 0 = black). */
export const darkenHex = (hex: string, factor = 0.85): string => {
  const h = hex.replace('#', '');
  const r = Math.round(parseInt(h.slice(0, 2), 16) * factor);
  const g = Math.round(parseInt(h.slice(2, 4), 16) * factor);
  const b = Math.round(parseInt(h.slice(4, 6), 16) * factor);
  return `#${r.toString(16).padStart(2, '0')}${g
    .toString(16)
    .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};

export const getStableUserColorHex = (seed: string): string => {
  const bgClass = getStableUserColor(seed);
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return USER_COLOR_HEX[bgClass as (typeof USER_COLORS)[number]] ?? '#D9D9D9';
};

export const TILE_BORDER = 'border-r-[0.5px] border-b-[0.5px] border-main-300';

export const FILLER_BORDER = '';

export const GRID_CONTAINER =
  'grid grid-cols-[repeat(auto-fill,minmax(320px,1fr))] w-full min-h-[360px]';
